const SIGNED_SALE_PARAMS = [
  "seller",
  "orderNonce",
  "nftContract",
  "tokenId",
  "paymentErc20TokenAddress",
  "price",
  "buyer",
  "expiresAt",
  "makerCut",
  "takerCut",
  "royaltiesCut",
  "royaltiesRecipient",
  "collectiveCut",
  "collectiveRecipient",
] as const;

const DUTCH_AUCTION_PARAMS = [
  "seller",
  "orderNonce",
  "nftContract",
  "tokenId",
  "paymentErc20TokenAddress",
  "startingPrice",
  "endingPrice",
  "startingAt",
  "duration",
  "makerFeePercentage",
  "takerFeePercentage",
  "royaltiesPercentage",
  "royaltiesRecipient",
  "collectiveFeePercentage",
  "collectiveRecipient",
] as const;

const RESERVE_AUCTION_PARAMS = [
  "signer",
  "v",
  "r",
  "s",
  "orderNonce",
  "price",
] as const;

const RESERVE_AUCTION_INFO_PARAMS = [
  "nftContract",
  "tokenId",
  "paymentErc20TokenAddress",
  "makerFeePercentage",
  "takerFeePercentage",
  "royaltiesPercentage",
  "royaltiesRecipient",
  "collectiveFeePercentage",
  "collectiveRecipient",
] as const;

const OFFER_PARAMS = [
  "bidder",
  "orderNonce",
  "nftContract",
  "tokenId",
  "paymentErc20TokenAddress",
  "price",
  "expiresAt",
  "isForCollection",
  "makerCut",
  "takerCut",
  "royaltiesCut",
  "royaltiesRecipient",
  "collectiveCut",
  "collectiveRecipient",
] as const;

export {
  SIGNED_SALE_PARAMS,
  DUTCH_AUCTION_PARAMS,
  RESERVE_AUCTION_PARAMS,
  RESERVE_AUCTION_INFO_PARAMS,
  OFFER_PARAMS,
};
